<template>
  
    <content-header
        icona="fas fa-check-double"
        titolo="Risultati"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">

           

           
        </div>
    </div>
    
</template>

<script>
//import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'RisulatatiView',
    components: {
        ContentHeader
    },
    inject: ['cfg'],
    data: function() {
        return {

           
        
        }
    },
    methods: {
      
       
      
    
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

             

    }
}
</script>